import { createEnvelopeSource } from './create-envelope-source';

/**
 * Churn source. Pure config over the standardized envelope
 * (`GET /analytics/churn`): `accountDeletions` / `accountSwaps` are scalar
 * counts, `churnRate` is the deletions-based ratio ((deletions - swaps) /
 * signups) as a fraction. All mapping/fetching lives in `createEnvelopeSource`.
 * The `line` form requests daily granularity; the backend serves a per-day
 * `accountDeletions` series (a count), so the line card is scoped to that metric.
 *
 * `churnRate` and `accountDeletions` are `lowerIsBetter`, matching
 * `technical-health.ts`'s `errorRate`/`failedSessions`: a rise in either is bad
 * news, so any card's trend colour must flip. `accountSwaps` is left neutral: a
 * swap nets against a deletion in `churnRate`'s own formula, so it is not
 * unambiguously bad on its own; that needs product input, not a default here.
 */
export const churnSource = createEnvelopeSource({
    label: 'Churn',
    endpoint: 'analytics/churn',
    metrics: [
        {
            id: 'accountDeletions',
            label: 'Account deletions',
            type: 'scalar',
            lowerIsBetter: true,
        },
        { id: 'accountSwaps', label: 'Account swaps', type: 'scalar' },
        {
            id: 'churnRate',
            label: 'Churn rate',
            type: 'ratio',
            lowerIsBetter: true,
        },
    ],
    forms: ['number', 'rate', 'line'],
    regionGrain: 'province',
});
